import z from 'zod'

import { AnchorType } from '@/shared/generated'
import i18n from '@/shared/i18n/client'

export const formSchema = z
	.object({
		anchor_type: z
			.enum(
				[
					AnchorType.Bundle,
					AnchorType.Flat,
					AnchorType.Ladder,
					AnchorType.ProductSet,
					AnchorType.Size,
				],
				{
					error: () =>
						i18n.t(
							'anchoring_management.assign_to_modal.validation.anchor_type_required',
							{
								defaultValue: 'Anchor type is required',
							}
						),
				}
			)

			.nullable(),
		anchor_product: z.object(
			{
				line_id: z.string(),
				line_name: z.string(),
				category_id: z.string(),
				category_name: z.string(),
				cost: z.number(),
				last_price: z.number(),
				sku: z.string(),
				title: z.string(),
				sales_entity_id: z.string(),
			},
			{
				error: () =>
					i18n.t(
						'anchoring_management.assign_to_modal.validation.main_product_required',
						{
							defaultValue: 'Main product is required',
						}
					),
			}
		),
		anchors: z.array(
			z.object({
				title: z.string(),
				sku: z.string(),
				sales_entity: z.object({
					id: z.string(),
					name: z.string(),
				}),
				cost: z.number(),
				last_price: z.number(),
				mul: z.number().nullable(),
				add: z.number().nullable(),
			})
		),
		source_family_id: z.string().optional(),
	})
	.superRefine((data, ctx) => {
		data.anchors.forEach((anchor, index) => {
			if (anchor.sku === data.anchor_product?.sku) {
				return true
			}
			const hasNonZero = (anchor.mul ?? 0) !== 0 || (anchor.add ?? 0) !== 0
			if (!hasNonZero) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['anchors', index],
				})
			}
		})
	})
